module.exports = __webpack_public_path__ + "img/icon100.89d68ef6.png";